import { BehaviorSubject } from 'rxjs';
import { NotificationModule } from '../Models/Notifications/NotificationMachine';
import { WebSocketMessageTypeIncoming } from '../Enums/WebSocketMessageTypeIncoming';
import { WsPotlijnNotificationItems } from '../Models/WebSocket/Incoming/WsPotlijnNotificationItems';
import { WsPotlijnNotificationItem } from '../Models/WebSocket/Incoming/WsPotlijnNotificationItem';
import { MessageWebSocket } from '../Models/WebSocket/MessageWebSocket';
import { serviceBundler, webSocketService } from '../App';
import { IMessageSock } from '../Models/WebSocket/IMessageSock';
import { ColorType } from '../Enums/ColorType';
import { ColorHelper } from '../Models/Devices/ColorOptions';
import { HttpHelper } from '../Helpers/HttpHelper';
import { WsRequestActiveNotifications } from '../Models/WebSocket/Outgoing/WsRequestActiveNotifications';

export class NotificationService {
  public notificationsChannel: BehaviorSubject<NotificationModule[] | null>;
  public notificationsToKillChannel: BehaviorSubject<
    NotificationModule[] | null
  >;

  public notificationsProcessed: Array<NotificationModule> =
    new Array<NotificationModule>();
  public notificationsToKill: Array<NotificationModule> =
    new Array<NotificationModule>();

  private lastTimePlayed = Date.now();
  private soundPlaying = false;
  private soundPlayed = false;
  private allowPlaying: boolean = true;
  private timeBeforeRemove = 3;

  constructor() {
    this.notificationsChannel = new BehaviorSubject<
      NotificationModule[] | null
    >(null);

    this.notificationsToKillChannel = new BehaviorSubject<
      NotificationModule[] | null
    >(null);

    webSocketService.messagesChannel.subscribe((value) => {
      this.HandleWebsockets(value);
    });

    webSocketService.sendMessage(new WsRequestActiveNotifications());

    let timerId = setInterval(() => this.RemoveDoneNotifications(), 1000);
  }

  private HandleWebsockets(msg: IMessageSock) {
    const prodItem = Object.assign(new MessageWebSocket(), msg);

    if (prodItem.Type == WebSocketMessageTypeIncoming.PotlijnNotificationItems) {
      var itemAdded = false;

      var notifications: WsPotlijnNotificationItems = Object.assign(
        new WsPotlijnNotificationItems(),
        msg,
      );

      var newList: NotificationModule[] = [];
      notifications.ListItems.forEach((element) => {
        var res = this.AddNotification(element);
        if (element.SensorValue) {
          res.fixed = true;
        }

        var foundIndex = this.notificationsProcessed.findIndex(
          (x) => x.sensorId === element.SensorId,
        );
        if (foundIndex >= 0) {
          this.notificationsProcessed[foundIndex] = res;
          newList.push(res);
        } else {
          if (!res.fixed) {
            itemAdded = true;
            this.notificationsProcessed.push(res);
            newList.push(res);
          }
        }
      });

      this.notificationsChannel.next(newList);

      if (itemAdded) {
        if (!this.soundPlaying) {
          this.PlayAudio();
        }
      }
    }
  }

  private GetNameFromColor(type: ColorType): string {
    var colors = ColorHelper.GetColors();
    var rightColor: string = '';

    colors.forEach((x) => {
      if (x.KeyName == type) {
        rightColor = x.ValueKey;
        return;
      }
    });
    return rightColor;
  }

  private AddTestNotification(SensorId: string) {
    return new NotificationModule(
      'exclamation-triangle',
      SensorId,
      'Grondbunker',
      false,
      'Welkommmm',
      'https://storage.cloudkwekerijbloemendaal.com/Images/ground.png',
      'DarkRed',
      'error',
    );
  }

  private AddNotification(notification: WsPotlijnNotificationItem) {
    return new NotificationModule(
      'exclamation-triangle',
      notification.SensorId,
      notification.ModuleName,
      notification.SensorValue,
      notification.Message,
      notification.UrlForImage,
      this.GetNameFromColor(notification.ColorMessage),
      'error',
    );
  }

  public AllowPlayAudio(value: boolean) {
    this.allowPlaying = value;
  }

  public PlayAudioIsAllowed() {
    return this.allowPlaying;
  }

  private async PlayAudio() {
    if (Date.now() + 50000 > this.lastTimePlayed) {
      this.lastTimePlayed = Date.now();
      if (this.allowPlaying) {
        var audio = new Audio(
          HttpHelper.GetUrlStorageBaseApi() +
            'Sounds/Potline/' +
            (await serviceBundler.settingsWebportalService.GetSetting()).currentSoundTrack,
        );
        audio.play();
      }
      this.soundPlayed = true;
    } else {
      return;
    }
  }

  private async RemoveDoneNotifications() {
    var setting = await serviceBundler.settingsWebportalService.GetSetting()
    if (setting !== undefined) {
      this.timeBeforeRemove =
        (await serviceBundler.settingsWebportalService.GetSetting()).timeForRemoveNotification;
    }

    var notiToKill: NotificationModule[] = [];
    this.notificationsProcessed.forEach((item, index) => {
      if (
        new Date(item.timeStamp).getTime() + this.timeBeforeRemove <
        new Date().getTime() / 1000
      ) {
        if (item.fixed) {
          notiToKill.push(item);
          this.notificationsProcessed.splice(index, 1);
        }
      }
    });

    if (notiToKill.length != 0) {
      this.notificationsToKillChannel.next(notiToKill);
    }
  }
}
